export function disableScrollOnNumberInputs() {
    document.addEventListener('wheel', function (ev) {
        if (document.activeElement.type === 'number') {
            document.activeElement.blur();
        }
    });
}
